export const TrashDeleteBinIcon = ({ ...props }) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" {...props}>
        <path d="m3 6h18m-16 0v14c0 1.1046.89543 2 2 2h10c1.1046 0 2-.8954 2-2v-14m-11 0v-2c0-1.10457.89543-2 2-2h4c1.1046 0 2 .89543 2 2v2" />
        <path d="m14 11v6" />
        <path d="m10 11v6" />
      </g>
    </svg>
  );
};
